import React from 'react'
import {Link} from 'react-router-dom'
import moment from 'moment';

import createArchiveContainer from '@components/Archive/createArchiveContainer'
import statuses from '@server/constants/statuses/job-statuses'
import { filterPresets } from '@modules/form/form.module'

import { JobModel } from '@modules/job/job.module'

export default createArchiveContainer({
	Model: JobModel,
	title: 'Jobs Board',
	// resourceType: 
	queryConfig: {
		defaults: {
			sortBy: 'status',
		},
		filters: filterPresets([
			['status', {
				options: [
					{ label: 'All', value: 'any' },
					...statuses.map(s => ({
						label: s.label,
						value: s.order,
					})),
				]
			}],
			'client',
			'jobType',
		]),
	},
	tableConfig: {
		columns: [
			{
				label: 'Status',
				prop: 'status',
				sortKey: 'status',
				getValue: (doc) => doc.status.label,
			},
			{
				label: 'Date Posted',
				// prop: 'createdAt',
				sortKey: 'createdAt',
				getValue(doc) {
					return moment(doc.createdAt).format('DD/MM/YYYY');
				}
			},
			{
				label: 'Client',
				// sortKey: 'client', // TODO: aggregate on backend to allow sort by nested objects
				getValue(doc) {
					return doc.client ? doc.client.label : '';
				}
			},
			{
				label: 'Job Type',
				// sortKey: 'jobType', // TODO: aggregate on backend to allow sort by nested objects
				getValue(doc) {
					return doc.jobType ? doc.jobType.label : '';
				}
			},
			{
				label: 'Candidate Name',
				getValue(doc) {
					return doc.positionHeldBy ? doc.positionHeldBy.label : '-';
				}
			}
		],
		rowLinks: (doc) => (
			<div>
				<Link className="TableRow-link" to={`job/${doc.id}`}>view</Link>
				<Link className="TableRow-link" to={`job/${doc.id}?edit=true`}>edit</Link>
			</div>
		),
	},
});




// WEBPACK FOOTER //
// ./src/scenes/Jobs/JobListContainer.jsx